"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDom = require("react-dom");

var _util = require("./util");

var _util2 = require("../../util");

var _default = function (View) {
  return View.extend({
    initialize: function initialize() {
      View.prototype.initialize.apply(this, arguments);
      this.on('render', this.renderComponents, this);
      this.on('close', this.tearDownComponents, this);
    },
    renderComponents: function renderComponents() {
      if (!this.components) {
        return;
      }

      this.tearDownComponents();
      var components = (0, _util2.result)(this, 'components');
      this._components = (0, _util.buildComponents)(this, components);
    },
    tearDownComponents: function tearDownComponents() {
      if (!this._components) {
        return;
      }

      this._components.forEach(function (el) {
        (0, _reactDom.unmountComponentAtNode)(el);
      });

      delete this._components;
    }
  });
};

exports.default = _default;